import React from "react";

import Wrapper from "src/components/Wrapper";

import { Content } from "./Content";

function ReportsPage() {
  return (
    <Wrapper>
      <Content />
    </Wrapper>
  );
}

export default ReportsPage;
